import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';

export default function isListHtmlElement(node: Node): node is TListHtmlElement {
    return isHtmlElementNode(node, 'OL') || isHtmlElementNode(node, 'UL');
}

// #region Types

export type TListHtmlElement = (HTMLOListElement & { tagName: 'OL' }) | (HTMLUListElement & { tagName: 'UL' });

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isListHtmlElement', () => {
        test('results with false for non-html elements', () => {
            expect(isListHtmlElement(document)).toBe(false);
            expect(isListHtmlElement(document.createTextNode('text'))).toBe(false);
        });

        test('results with true only for list html elements', () => {
            expect(isListHtmlElement(document.createElement('ul'))).toBe(true);
            expect(isListHtmlElement(document.createElement('ol'))).toBe(true);
            expect(isListHtmlElement(document.createElement('li'))).toBe(false);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isListHtmlElement(node)
                ? expectTypeOf(node).toMatchTypeOf<HTMLOListElement | HTMLUListElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLOListElement | HTMLUListElement>();
        });
    });
}

// #endregion
